import { fetcher } from '@commenda/utils';

type SyncFromPoliciesResult =
  | { ok: true; data: { created: number } }
  | { ok: false; error: string };

const syncFromPolicies = async (
  companyId: number
): Promise<SyncFromPoliciesResult> => {
  const res = await fetcher(
    `tp-document-record/sync-from-policies?companyId=${companyId}`,
    {
      method: 'POST',
    }
  );

  if (!res.ok) {
    return { ok: false, error: 'Failed to sync local files from policies' };
  }

  const data = (await res.json()) as { created: number };
  return { ok: true, data };
};

export { syncFromPolicies };
export type { SyncFromPoliciesResult };
